const getNonce = () => {
    if(
        matrixParams && 
        matrixParams.hasOwnProperty('ajax_nonce') &&
        matrixParams.ajax_nonce
    ) {
        return matrixParams.ajax_nonce
    } else {
        return false
    }
}

export default getNonce
